import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Links from "../src/Components/Links";

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Links />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
